export const sumValues = (rows, column) => rows.reduce((acc, r) => (
  acc + (r[column] && r[column].value ? r[column].value : 0)
), 0);

// собирает id проектов из полей projIds в столбцах, по которым надо собрать суммарное количество проектов,
// выбирает из получившегося массива уникальные ids,
// и возвращает длину массива из уникальных значений id проектов
export const sumDistinctProjs = (rows, ...columns) => _.uniq(rows.reduce((acc, r) => [
  ...acc,
  ...columns.reduce((projIds, col) => [...projIds, ...(r[col] && r[col].projIds ? r[col].projIds : [])], []),
], []))
  .length;

export const getValueColumns = (years, fundings) => {
  const withBasePart = !fundings || fundings.includes('base');
  const withSpecialPart = !fundings || fundings.includes('special');

  return years.reduce((acc, year) => [
    ...acc,
    withBasePart && `plan${year}B`,
    withSpecialPart && `plan${year}S`,
    withBasePart && `planApproved${year}B`,
    withSpecialPart && `planApproved${year}S`,
    withBasePart && `fact${year}B`,
    withSpecialPart && `fact${year}S`,
  ], []).filter((v) => v);
};

export const getTotalColumns = (years, fundings) => {
  const withBasePart = !fundings || fundings.includes('base');
  const withSpecialPart = !fundings || fundings.includes('special');

  return years.reduce((acc, year) => [
    ...acc,
    withBasePart && `plan${year}TotalB`,
    withSpecialPart && `plan${year}TotalS`,
    withBasePart && `plan${year}ApprovedTotalB`,
    withSpecialPart && `plan${year}ApprovedTotalS`,
    withBasePart && `fact${year}TotalB`,
    withSpecialPart && `fact${year}TotalS`,
  ], []).filter((v) => v);
};

export const getTotalSumColumns = (years) => years.reduce((acc, year) => [
  ...acc,
  `plan${year}TotalAll`,
  `plan${year}ApprovedTotalAll`,
  `fact${year}TotalAll`,
], []);

export const getTotalData = (renderData, years, fundings) => {
  const withBasePart = !fundings || fundings.includes('base');
  const withSpecialPart = !fundings || fundings.includes('special');

  const filteredData = renderData.map((r) => r.tableData.childRows).flat();

  return years.reduce((acc, year) => {
    const planTotalB = withBasePart ? sumValues(filteredData, `plan${year}B`) : 0;
    const planTotalS = withSpecialPart ? sumValues(filteredData, `plan${year}S`) : 0;
    const planTotalAll = planTotalB + planTotalS;

    const planApprovedTotalB = withBasePart ? sumDistinctProjs(filteredData, `planApproved${year}B`) : 0;
    const planApprovedTotalS = withSpecialPart ? sumDistinctProjs(filteredData, `planApproved${year}S`) : 0;
    const planApprovedTotalAll = sumDistinctProjs(filteredData, withBasePart ? `planApproved${year}B` : '', withSpecialPart ? `planApproved${year}S` : '');

    const factTotalB = withBasePart ? sumDistinctProjs(filteredData, `fact${year}B`) : 0;
    const factTotalS = withSpecialPart ? sumDistinctProjs(filteredData, `fact${year}S`) : 0;
    const factTotalAll = sumDistinctProjs(filteredData, withBasePart ? `fact${year}B` : '', withSpecialPart ? `fact${year}S` : '');

    return {
      ...acc,
      [`plan${year}TotalB`]: {value: planTotalB},
      [`plan${year}TotalS`]: {value: planTotalS},
      [`plan${year}TotalAll`]: {value: planTotalAll},
      [`plan${year}ApprovedTotalB`]: {value: planApprovedTotalB},
      [`plan${year}ApprovedTotalS`]: {value: planApprovedTotalS},
      [`plan${year}ApprovedTotalAll`]: {value: planApprovedTotalAll},
      [`fact${year}TotalB`]: {value: factTotalB},
      [`fact${year}TotalS`]: {value: factTotalS},
      [`fact${year}TotalAll`]: {value: factTotalAll},
    };
  }, {});
};
